import { create } from "zustand";
import { toast } from "sonner";
import { addPropertyColor, removePropertyColor } from "@/lib/api";

export const FAVORITE_COLORS = [
  { key: "red", hex: "#ef4444" },
  { key: "orange", hex: "#f97316" },
  { key: "yellow", hex: "#eab308" },
  { key: "green", hex: "#22c55e" },
  { key: "blue", hex: "#3b82f6" },
];

export const useFavorites = create((set, get) => ({
  overrides: {},

  getColor: (property) => {
    if (!property?.idProperty) return null;
    const id = property.idProperty;
    const o = get().overrides[id];
    if (o !== undefined) return o;
    return property.color || null;
  },

  isFav: (property) => !!get().getColor(property),

  setColor: async (property, color) => {
    const id = property?.idProperty;
    if (!id) return;
    const prevColor = get().getColor(property);
    if (prevColor === color) return;
    set((s) => ({ overrides: { ...s.overrides, [id]: color } }));
    try {
      if (color) {
        await addPropertyColor(id, color);
      } else {
        await removePropertyColor(id);
      }
    } catch (e) {
      set((s) => ({ overrides: { ...s.overrides, [id]: prevColor } }));
      toast.error(
        e?.response?.status === 401
          ? "Seçilmişlərə əlavə etmək üçün daxil olun"
          : e.message || "Əməliyyat uğursuz oldu"
      );
    }
  },
}));